<template>
  <div id="followCase">
    <div v-if="isLoading" class="spinner text-center">
      <img width="100" src="https://cdn.gavleenergi.se/img/spinner.svg" />
    </div>
    <div v-else class=""> 
        <ul class="nav nav-pills mb-4 gap-2"  role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link active px-4" id="active-tab" data-bs-toggle="tab" data-bs-target="#active" type="button" role="tab" aria-controls="active" aria-selected="true">Pågående</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link px-4" id="closed-tab" data-bs-toggle="tab" data-bs-target="#closed" type="button" role="tab" aria-controls="closed" aria-selected="false">Avslutade</button>
            </li>
        </ul>
        <div class="tab-content">
            <div class="tab-pane active" id="active" role="tabpanel" aria-labelledby="active-tab" tabindex="0">
              <sosItem :items='openItems'></sosItem>
              </div>
            <div class="tab-pane" id="closed" role="tabpanel" aria-labelledby="closed-tab" tabindex="0">
               <sosItem :items='closedItems'> </sosItem>
            </div>

        </div>

    </div>
  </div>

  <ComponentStyles>
    body{ background: #EFEEEA; } #followCase .timeline-steps ul{ padding: 0; }
    #followCase .timeline-steps .step { border-left: none; grid-row: 1 / auto; text-align:
    left; display: grid; max-width: 650px; grid-template-columns: 42px 1fr; gap:
    1.5rem } #followCase .timeline-steps .step .icon { -webkit-box-pack: start;
    justify-content: flex-start; flex-direction: column; -webkit-box-align:
    center; position: relative; z-index: 1; height: auto; } #followCase .timeline-steps .step .icon .inside
    { width: 42px; height: 42px; background: #fff; margin: 0; text-align:
    center; line-height: 42px; border-radius: 200px; font-size: 18px; box-shadow:0 2px 3px rgba(0, 0, 0, 0.2) !important; } 
    #followCase .timeline-steps .step.done .icon .inside { background: #e1ffd6; color:
    #1c614c; } #followCase .timeline-steps .step.current .icon .inside { background:
    #47525D; color: #fff; } #followCase .timeline-steps .step:not(:last-of-type)
    .icon::before { width: 1px; height: 84%; left: 50%; top: 42px; border: 1px
    dashed #dee2e6; } #followCase .timeline-steps .step .icon::before { content: "";
    display: block; position: absolute; /*background: #b5b9bb;*/ top: 50%; left:
    0px; right: 0px; } #followCase .timeline-steps .step .text { padding: 6px 0 25px 0;
    display: grid; /*gap: 8px;*/ } #followCase .timeline-steps .step.current .text{ color:
    #47525D;}.ignored .text .checklistHeader{text-decoration: line-through !important;}
    #followCase .nav-pills .nav-link{ background: #fff; color: #47525D; border-radius: 300px; border: 2px solid #47525D; font-weight:bold; }
    #followCase .nav-pills .nav-link.active, .nav-pills .show>.nav-link{background: #47525D; color: #fff; position: relative; }
    #followCase .nav-pills .nav-link.active:after{content:'';position: absolute; left: 0; right: 0; bottom: -10px; margin: 0 auto; width: 0; height: 0; border-top: 10px solid #47525D; border-left: 10px solid transparent; border-right: 10px solid transparent;}
  </ComponentStyles>
</template>
<script>
const formatDate = (timestamp) => timestamp.slice(0, 10).replace("T", " ");
import ComponentStyles from "../componentStyles.vue";
import sosItem from "./sosItem.vue";

export default {
  props: [ 'cc' ],
  components: { ComponentStyles, sosItem },
  data() {
    return {

      isLoading: false,
      closedItems: [],
      openItems: [],
      checklists: [],
      notes: [],
    };
  },

  methods: {
    formatDate,

    async getData() {
      this.isLoading = true;
      try {
        const response = await fetch(
          //"https://getstweb23.gavleenergi.se/test/followCase.php?id="+this.cc,
          "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/followCase/index.php?id="+this.cc, {headers: {"api-key": "MfrUXeKQxI"}}
         );
        const data = await response.json();
       /* data.map(item => {
          item.open ? this.openItems.push(item):this.closedItems.push(item)
        });
        */

        
        data.forEach(item => {
          if (item.open === true) {
            if (item.status === 'Avslutat') {
              this.closedItems.push(item);
            } 
            else {
              this.openItems.push(item);
            }
          }
          else {
            this.closedItems.push(item);
            }
        });


        //console.log(data);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isLoading = false;
      }
    },

  },

  mounted() {
    this.getData();
  },
};

</script>
